import { calendarDate } from '../../utils/date-time';
import { api } from '../../AxiosConfig';

class HorariosAtendenteService {
    cancel(horarioId: string) {
        return api.post(`/horarios/atendente/cancel`, { horarioId });
    }

    approve(horarioId: string) {
        return api.post(`/horarios/atendente/approve`, { horarioId });
    }

    conclude(horarioId: string, paymentMethod?: string) {
        return api.post(`/horarios/atendente/conclude`, { horarioId, paymentMethod });
    }

    changePayment(horarioId: string, paymentMethod: string) {
        return api.post(`/horarios/atendente/change-payment`, { horarioId, paymentMethod });
    }

    registerPayment(horarioId: string, paymentMethod: string) {
        return api.post(`/horarios/atendente/register-payment`, { horarioId, paymentMethod });
    }

    getHorariosCards(date: Date, attendantId: string) {
        const dateString = calendarDate(date);
        return api.get(`/horarios/atendente/cards`, {
            params: { date: dateString, attendantId },
        });
    }

    getProjecao(date: Date, attendantId: string) {
        const dateString = calendarDate(date);
        return api.get(`/horarios/projecao`, {
            params: { date: dateString, attendantId },
        });
    }

    getPrecoPreview(params: {
        clientId: string;
        servicoId: string;
        servicosExtrasIds: string[];
        localDate: string;
        startMinutes: number;
    }) {
        return api.get(`/horarios/atendente/preco`, {
            params: {
                clientId: params.clientId,
                servicoId: params.servicoId,
                localDate: params.localDate,
                startMinutes: params.startMinutes,
                'servicosExtrasIds[]': params.servicosExtrasIds,
            },
        });
    }

    createAgendamento(agendamentoData: {
        startAt?: Date;
        localDate?: string;
        servicoId: string;
        servicosExtrasIds?: string[];
        attendantId: string;
        startMinutes: number;
        clientId: string;
        observation: string;
        valor?: number;
        priceManual?: boolean;
        recorrencia: any;
        duration?: number;
        assinaturaId?: string;
    }) {
        return api.post(`/horarios/atendente/agendar`, agendamentoData);
    }

    editAgendamento(agendamentoData: {
        _id: string;
        startAt?: Date;
        localDate?: string;
        servicoId: string;
        servicosExtrasIds?: string[];
        attendantId: string;
        startMinutes: number;
        clientId: string;
        observation: string;
        observationClient?: string;
        valor?: number;
        priceManual?: boolean;
        recorrencia?: any;
        duration?: number;
    }) {
        return api.patch(`/horarios/atendente/agendar`, agendamentoData);
    }

    updatePrice(horarioId: string, price: number) {
        return api.patch(`/horarios/price/${horarioId}`, { price });
    }

    updateObservation(horarioId: string, observation: string) {
        return api.patch(`/horarios/observation/${horarioId}`, { observation });
    }

    async updateObservationClient(id: string, observationClient: string) {
        return api.patch(`/horarios/observation-client/${id}`, { observationClient });
    }

    getUltimosAgendamentosByCliente(clienteId: string, data: Date, atendenteId: string) {
        const dataString = data.toISOString();
        return api.get(`/horarios/ultimos-agendamentos-cliente`, {
            params: { clienteId, atendenteId, data: dataString },
        });
    }
}

export { HorariosAtendenteService };
